/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from 'react';
import { Button } from '@mui/material';
import { Config } from 'config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
import { getFields, getValue } from 'cms/utils/values-settings';
import { RichTextSimple } from 'cms/rich-text/rich-text-simple';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from 'icons';
const { faPlus, faMinus, faTriangleExclamation } = solid;

export const LiveAlertBanner = (props) => {
    const alert = props?.alert;
    const enabled = props?.enabled;
    const collapseBanner = props?.collapseBanner;
    const showBanner = props?.showBanner;
    const handleToggleBanner = props?.handleToggleBanner;
    const onClickBanner = props?.onClickBanner;

    if (!alert || !alert.model || !alert.webpage) {
        return null;
    }

    if (showBanner && enabled) {
        const model = alert?.model;
        const webpage = alert?.webpage;
        const title = model?.title;
        const updated_at = model?.updated_at;
        const path = webpage?.path;
        const fields = getFields(model);
        const summary = fields?.summary;

        // Get the value of the Summary directly avoiding useSimplicity (not a regular webpage/model).
        const summaryValue = getValue(summary);
        const date = dayjs.utc(updated_at).local().format(Config.dateFormat.date_short_no_year);
        const time = dayjs.utc(updated_at).local().format(Config.dateFormat.time);

        const handleClickBanner = (event) => {
            onClickBanner(event, path);
        };
        const isCollapsedClass = collapseBanner === true ? 'collapsed' : '';

        return (
            <div className={`alert-banner ${isCollapsedClass}`}>
                <span className='alert-banner-icon'>
                    <FontAwesomeIcon icon={faTriangleExclamation} size='2xl' />
                </span>
                <div className='alert-banner-container'>
                    <div className='alert-banner-content'>
                        <div className={`alert-banner-header ${isCollapsedClass}`}>
                            <div className='alert-banner-header-text'>
                                <span className='alert-banner-title'>{title}</span>
                                <span className='alert-banner-time-stamp'>
                                    Updated {date} - {time}
                                </span>
                            </div>
                            <div className='btn-wrapper'>
                                <button className='btn-close' onClick={handleToggleBanner}>
                                    {collapseBanner && <FontAwesomeIcon icon={faPlus} size='1x' />}
                                    {!collapseBanner && <FontAwesomeIcon icon={faMinus} size='1x' />}
                                </button>
                            </div>
                        </div>
                        <div className={`alert-banner-inner-content ${isCollapsedClass}`}>
                            <RichTextSimple richtext={summaryValue} />
                            <div className='alert-banner-actions'>
                                <Button className='LearnMore' onClick={handleClickBanner}>
                                    Learn more
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};
